var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleOutline = function SvgCheckCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Check_Circle_Outline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 26.5c-2.935 0-5.7-1.14-7.78-3.222A10.882 10.882 0 0 1 4 15.508a10.94 10.94 0 0 1 3.22-7.786A10.9 10.9 0 0 1 15 4.5c1.553 0 3.064.314 4.474.955.599.271 1.183.585 1.71.956L19.659 7.68c-1.31-.884-2.963-1.355-4.673-1.355A9.07 9.07 0 0 0 8.503 9.02a9.081 9.081 0 0 0-2.693 6.487c0 2.452.954 4.762 2.678 6.487a9.07 9.07 0 0 0 6.484 2.695c2.45 0 4.744-.955 6.483-2.695a9.081 9.081 0 0 0 2.693-6.487c0-.727-.086-1.454-.243-2.139l-.156-.641-10.031 8.483-.428-.513-.1.071-.512-.812-.485-.57-.128-.2-3.505-4.449 1.994-1.582 3.72 4.719 9.93-8.384.03.029A10.973 10.973 0 0 1 26 15.493a10.94 10.94 0 0 1-3.22 7.785A10.9 10.9 0 0 1 15 26.5Z",
    fill: "#DAC6AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Check_Circle_Outline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4.5)",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgCheckCircleOutline;